export enum TESTIMONY_PERMISSIONS {
  TESTIMONY_VIEW = 'CONTENT_TESTIMONYVIEW',
  TESTIMONY_WRITE = 'CONTENT_TESTIMONYWRITE',
}
